// pages/Home.js
import React, { useEffect, useState } from "react";
import sanityClient from "../sanityClient";
import HeroSection from "../components/HeroSection";
import AboutUs from "../components/AboutUs";
import UseCases from "../components/UseCases";
import KeyFeatures from "../components/KeyFeatures";
import SSDSection from "../components/SSDSection";
import Footer from "../components/Footer";

const Home = () => {
  const [heroData, setHeroData] = useState(null);
  const [aboutData, setAboutData] = useState(null);
  const [useCaseData, setUseCaseData] = useState(null);

  useEffect(() => {
    sanityClient.fetch(`*[_type == "heroSection"][0]`).then(setHeroData);
    sanityClient.fetch(`*[_type == "aboutSection"][0]`).then(setAboutData);
    sanityClient.fetch(`*[_type == "useCaseSection"][0]`).then(setUseCaseData);
  }, []);

  return (
    <>
      <div id="home">
        <HeroSection
          headline={
            heroData?.headline ||
            "Triple sales with Real-Time behavioral AI from your existing cameras"
          }
          subheadline={
            "Neuora transforms shopper behavior into sales actions — in 48 hours, no new hardware needed."
          }
        />
      </div>

      <div id="about">
        <AboutUs data={aboutData} />
      </div>

      <div id="usecases">
        <UseCases data={useCaseData} />
      </div>

      <div id="features">
        <KeyFeatures />
      </div>

      <SSDSection />
      <Footer />
    </>
  );
};

export default Home;
